import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {UserLight} from 'src/app/users-module/models/userLight';
import {Router} from '@angular/router';
import {UserService} from 'src/app/users-module/services/user.service';
import * as moment from 'moment';
import {ToastrService} from 'ngx-toastr';
import { UserFilter } from 'src/app/users-module/models/userFilter';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.less']
})
export class UsersListComponent implements OnInit, OnDestroy {

  @Input()
  public clientId: number;

  @Input()
  public craCheck: boolean;

  @Input()
  public propertyId: number;

  constructor(public location: Router, public userService: UserService, private readonly toastrService: ToastrService) {
  }
  ngOnDestroy(): void {
    this.userService.userFilter = new UserFilter();
  }

  public get clientUsers(): Array<UserLight> {
    return this.userService.users;
  }

  public ngOnInit(): void {
    if (this.craCheck) {
      this.userService.FetchUserList(this.userService.userFilter);
    } else if (this.clientId > 0) {
      this.userService.FetchUsersForClient(this.clientId);
    } else if (this.propertyId > 0) {
      this.userService.FetchUsersForLocation(this.propertyId);
    }
  }


  public viewUser(usr: UserLight) {
    this.location.navigateByUrl(`users/review/${usr.id}/${this.clientId}`);
  }

  // this probably should live somewhere else, but most things use screening srv...
  public formatAsUTCLocal(date: Date, showTime?: boolean): string {
    if (date === undefined || date == null) {
      return null;
    }

    const m = moment.utc(date);
    if (!m.isValid()) {
      return null;
    }
    if (showTime) {
      return m.local().format('M/D/YYYY h:mm A');
    }
    return m.local().format('M/D/YYYY');
  }

  public resendInvite(item: UserLight): void {
    this.userService.ResendInvite(item.inviteToken).subscribe((rsp: any) => {
        this.toastrService.success('User invite sent.', 'Invite Sent!');

        item.invitedDate = rsp.invitedDate;
      },
      (err: any) => {
        this.toastrService.error('User invite failed.', 'Invite Failed!');
      });
  }

}
